"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["style", "onPress", "testID", "children"],
  _excluded2 = ["width", "height"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IMGElementContainer;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _GenericPressable = _interopRequireDefault(require("../GenericPressable"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignSelf: 'stretch',
    justifyContent: 'center'
  }
});
/**
 * Container for the {@link IMGElement} component.
 */

function IMGElementContainer(_ref) {
  var style = _ref.style,
    onPress = _ref.onPress,
    testID = _ref.testID,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var containerStyle = (0, _react.useMemo)(function () {
    var width = style.width,
      height = style.height,
      remainingStyle = _objectWithoutProperties(style, _excluded2);
    return [styles.container, remainingStyle];
  }, [style]);
  var Container = typeof onPress === 'function' ? _GenericPressable.default : _reactNative.View;
  return /*#__PURE__*/_react.default.createElement(Container, _objectSpread(_objectSpread({}, otherProps), {}, {
    style: containerStyle,
    onPress: onPress,
    testID: testID
  }), children);
}